export const CALENDAR_GRID_DAY_CHIP_LIMIT = 2

export const CALENDAR_GRID_DAY_LOAD_CHIP_COUNT = 1

export const QA_NAME_CALENDAR_GRID_DAY_MORE = 'calendarGridDayMore'
